import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";
import { colors } from "../../styles/color";
import { useNavigate } from "react-router-dom";
import { fetchBlogs } from "../../redux/features";
import { useAppDispatch } from "../../hooks/useAppReducer";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

const Blog = () => {
  const useStyles: any = makeStyles({
    conatiner: {
      maxWidth: "1280px !important",
      margin: "auto",
      padding: "0 24px 24px 20px",
    },
  });
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { blogList } = useSelector((state: any) => state.blogList);

  useEffect(() => {
    dispatch(fetchBlogs());
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>Latest Influencer Marketing Blogs | Strategies for Brands</title>
        <meta
          name="description"
          content=" 
 	
Read the latest influencer marketing news, brand collaboration tips, and expert insights on the Quickfluence blog to help you grow your online presence."
        />

        {/* Canonical */}
        <link rel="canonical" href="https://quickfluence.com/blog" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Quickfluence Blog for Creator and Brand Strategies"
        />
        <meta
          property="og:description"
          content=" 
 	
Read the latest influencer marketing news, brand collaboration tips, and expert insights on the Quickfluence blog to help you grow your online presence."
        />
        <meta property="og:url" content="https://quickfluence.com/blog" />
        <meta property="og:site_name" content="quickfluence" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en" />
        <meta
          property="og:image:alt"
          content="Quickfluence blog with influencer trends and expert tips"
        />
        <meta
          property="og:image"
          content="https://quickfluence.com/static/media/WorkWithImg.7fac11e7ad4c6bde8580.png"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <Box className={classes.conatiner}>
        <Box
          component="h1"
          sx={{
            fontSize: {
              xs: "20px",
              sm: "24px",
              md: "28px",
            },
            mt: {
              xs: "28px",
              sm: "60px",
            },

            display: "flex",
            justifyContent: "center",
            fontFamily: "Poppins",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: {
              xs: "32px",
              sm: "38px",
              md: "42px",
            },
            color: colors.basics.white,
            textAlign: "center",
          }}
        >
          Our{" "}
          <Box
            component="h1"
            sx={{
              fontSize: {
                xs: "20px",
                sm: "24px",
                md: "36px",
              },
              ml: "8px",
              marginBottom: "0px",
              marginTop: "0px",
              color: colors.basics.primary,
            }}
          >
            Blogs
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            mt: "15px",
            mb: "60px",
          }}
        >
          <Typography
            sx={{
              color: colors.gray[500],
              lineHeight: {
                xs: "28px",
                sm: "32px",
                md: "180%",
              },
              margin: "auto !important",
              display: "flex",
              justifyContent: "center",
              maxWidth: "600px",
              textAlign: "center",
              width: "100%",
              m: {
                xs: "12px 0 28px",
                sm: "16px 0 32px",
                md: "16px 0 40px",
              },
              fontSize: {
                md: "18px",
                xs: "14px",
              },
              fontWeight: 400,
            }}
            variant="body2"
          >
            Learn, grow, and get inspired with content crafted for creators and
            brands alike.
          </Typography>
        </Box>
        <Grid
          container
          columnSpacing={3.75}
          rowSpacing={{
            xs: 2,
            sm: 3,
            md: 7.5,
          }}
          sx={{ mt: "60px", pb: "100px" }}
        >
          {blogList?.data?.data?.map((post: any) => (
            <Grid item xs={12} sm={6} md={4} key={post.id}>
              <Card
                sx={{
                  p: "20px",
                  background: "#1D1D1D",
                  color: "white",
                  borderRadius: "20px",
                  overflow: "hidden",
                  // height: "100%",
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={post?.meta.image}
                  alt={post?.title}
                  sx={{
                    borderRadius: "20px",
                  }}
                />
                <CardContent
                  sx={{
                    px: 0,
                    pb: "0 !important",
                    ".MuiButtonBase-root": {
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                    },
                  }}
                >
                  {/* Title (2 lines max) */}
                  <Typography
                    variant="h6"
                    // component="div"
                    sx={{
                      fontWeight: "bold",
                      mb: 1,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      lineHeight: {
                        xs: "28px",
                        sm: "32px",
                        md: "180%",
                      },
                      fontSize: {
                        xs: "14px",
                        md: "20px",
                      },
                    }}
                  >
                    {post?.title}
                  </Typography>

                  {/* Description (2 lines max) */}
                  <Typography
                    variant="body2"
                    sx={{
                      lineHeight: {
                        xs: "28px",
                        sm: "32px",
                        md: "180%",
                      },
                      fontSize: {
                        xs: "14px",
                      },
                      color: "gray",
                      mb: 2,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {console.log("post :", post)}
                    {post?.excerpt}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        display: "block",
                        mb: 1,
                        color: colors.gray[300],
                        lineHeight: {
                          xs: "28px",
                          sm: "32px",
                          md: "180%",
                        },
                        fontSize: {
                          xs: "14px",
                        },
                        fontWeight: 500,
                      }}
                    >
                      By {post?.author_name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        display: "block",
                        mb: 1,
                        color: colors.gray[300],
                        lineHeight: {
                          xs: "28px",
                          sm: "32px",
                          md: "180%",
                        },
                        fontSize: {
                          xs: "14px",
                        },
                        fontWeight: 500,
                      }}
                    >
                      {post.published_at}
                    </Typography>
                  </Box>
                  <Button
                    onClick={() => navigate(`/blog/${post.slug}`)}
                    variant="outlined"
                    sx={{
                      width: "100%",
                      borderColor: "#343434",
                      background: "transparent",
                    }}
                  >
                    Read more
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default Blog;
